document.addEventListener("DOMContentLoaded", function () {
  function initLanorVariantLogic() {
    const colorInputs = document.querySelectorAll('input[name="Color"]');
    const macrameSection = document.querySelector('[data-option-name="Macramé Necklace"]');

    if (!colorInputs.length || !macrameSection) return;

    // في البداية نخفي خيارات العقد
    macrameSection.style.opacity = "0.4";
    macrameSection.style.pointerEvents = "none";

    // لما المستخدم يختار لون
    colorInputs.forEach((input) => {
      input.addEventListener("change", () => {
        if (input.checked) {
          macrameSection.style.opacity = "1";
          macrameSection.style.pointerEvents = "auto";
        }
      });
    });
  }

  // نعيد تشغيل الدالة بعد تحميل الصفحة أو بعد تحديث الـ variants
  initLanorVariantLogic();
  document.addEventListener("shopify:section:load", initLanorVariantLogic);
  document.addEventListener("shopify:section:select", initLanorVariantLogic);
});
